module.exports = __webpack_public_path__ + "static/media/BarlowSemiCondensed-Thin.8f5fc2c2.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowSemiCondensed-Thin.ttf
// module id = 2881
// module chunks = 51